import "./InvestmentStrategy.module.css";
import Header from "@/reusable_sections/Header";
import StrategyHero from "./sections/StrategyHero";
import Footer from "@/reusable_sections/Footer";
export default function InvestmentStrategyPage() {
  return <div>
      <Header />
      <StrategyHero />
      <Footer />
    </div>;
}